import { render, staticRenderFns } from "./dataCenter-echart4.vue?vue&type=template&id=921cf20e&scoped=true&"
import script from "./dataCenter-echart4.vue?vue&type=script&lang=js&"
export * from "./dataCenter-echart4.vue?vue&type=script&lang=js&"
import style0 from "./dataCenter-echart4.vue?vue&type=style&index=0&id=921cf20e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921cf20e",
  null
  
)

export default component.exports